/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        checkbox: {
            width: {
                value: "18px",
                type: "dimension",
            },
            height: {
                value: "18px",
                type: "dimension",
            },
            borderRadius: {
                value: "0",
                type: "dimension",
            },
            borderWidth: {
                value: "2px",
                type: "dimension",
            },
            borderColor: {
                value: "#2F3B4D",
                type: "color",
            },
            gap: {
                value: "6px",
                type: "dimension",
            },
            padding: {
                value: "3px",
                type: "dimension",
            },
            checked: {
                backgroundColor: {
                    value: "#2F3B4D",
                    type: "color",
                },
            },
            label: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            disabled: {
                borderColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
                label: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
                checked: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
